var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestrictedArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00011 2.05566C7.62663 2.05566 6.28399 2.46295 5.14198 3.22601C3.99998 3.98908 3.10989 5.07365 2.58428 6.34258C2.05867 7.61151 1.92115 9.00781 2.1891 10.3549C2.45706 11.702 3.11845 12.9394 4.08965 13.9106C5.06085 14.8818 6.29823 15.5432 7.64532 15.8111C8.99241 16.0791 10.3887 15.9415 11.6576 15.4159C12.9266 14.8903 14.0111 14.0002 14.7742 12.8582C15.5373 11.7162 15.9446 10.3736 15.9446 9.00011C15.9446 8.08815 15.7649 7.18512 15.4159 6.34258C15.0669 5.50005 14.5554 4.7345 13.9106 4.08964C13.2657 3.44479 12.5002 2.93327 11.6576 2.58428C10.8151 2.23529 9.91207 2.05566 9.00011 2.05566V2.05566ZM2.91986 9.00011C2.91516 7.83595 3.24519 6.69498 3.87063 5.7131C4.49608 4.73121 5.39059 3.94981 6.4476 3.46196C7.50462 2.9741 8.67958 2.80037 9.83255 2.96144C10.9855 3.12252 12.0679 3.61162 12.9507 4.37048L4.41678 13.0125C3.44464 11.9026 2.91219 10.4755 2.91986 9.00011V9.00011ZM9.00011 15.0726C7.5389 15.0738 6.12692 14.5446 5.02635 13.5834L13.5834 5.02634C14.3431 5.90515 14.8343 6.98361 14.9988 8.13351C15.1633 9.28341 14.9942 10.4564 14.5114 11.5129C14.0286 12.5694 13.2526 13.4651 12.2756 14.0934C11.2986 14.7217 10.1617 15.0563 9.00011 15.0572V15.0726Z",
    fill: "#0089EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestrictedArea);
export default __webpack_public_path__ + "static/media/restricted-area.b4c6ab2519080421a253489e1ac664e9.svg";
export { ForwardRef as ReactComponent };